/* src/components/project-tis/project-tis.component.scss */
:host {
  display: block;
  --table-border-size: 1px;
}
.main-wrapper {
  padding-top: 2rem;
}
.tis {
  padding-left: var(--vwui-size-component-nav);
}
.tis-theme {
  margin-bottom: var(--vwui-size-spacing-xl);
}
.header-subtitle {
  display: block;
  font-size: var(--vwui-size-font-xs);
  font-weight: normal;
}
.tis-col {
  vertical-align: middle;
}
.tis-col--question,
.tis-col--attachments-label {
  white-space: normal;
  --padding-heading-left: 2.75rem;
  --padding-column-left: 2.75rem;
  width: 24rem;
  max-width: 40vw;
}
.tis-col--answer,
.tis-col--attachments-list {
  width: 24rem;
  max-width: 60vw;
}
.tis-col--with-attachments {
  border-bottom: 0;
}
.tis-colattachments {
  border-top: 0;
}
.spacing-mb {
  margin-bottom: 1rem;
}
.text-warning {
  color: red;
}
.question--required:after {
  content: "*";
  margin-left: 0.25em;
  color: red;
}
/*# sourceMappingURL=project-tis.component-4CQW7O2K.css.map */
